export type TestingStatus = { activated: boolean; text: string };

export interface AssetsTesting {
  /*🤫
🤫
🤫*/
  testing: {
    /*🤫
🤫
🤫
🤫
🤫*/
    activate: () => string;
    /*🤫
🤫
🤫
🤫
🤫*/
    deactivate: () => string;
    /*🤫
🤫
🤫
🤫
🤫
🤫*/
    status: () => TestingStatus;
  };
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/
function getStatus(): TestingStatus {
  if (document.cookie.match(/AS_testing=true/i)) {
    return { activated: true, text: "activated" };
  }
  return { activated: false, text: "deactivated" };
}

/*🤫
🤫
🤫
🤫
🤫*/
function activate(): string {
  if (!getStatus().activated) {
    document.cookie = "AS_testing=true";
  }

  return getStatus().text;
}

/*🤫
🤫
🤫
🤫
🤫*/
function deactivate(): string {
  if (getStatus().activated) {
    document.cookie = `AS_testing=; expires=${new Date().toUTCString()}`;
  }

  return getStatus().text;
}

window.AS = window.AS || {};

/*🤫
🤫
🤫
🤫
🤫*/
window.AS.testing = { activate, deactivate, status: getStatus };
